module.exports = __webpack_public_path__ + "static/homepage-desktop-tm-lewin-0b814c241c1c7176614fa1ae814d1457.jpg";